import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from './base/base.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class VideoService  extends BaseService {

  private env = environment;

  constructor(
    http: HttpClient,
    errorHandlerService: ErrorHandlerService,) {
      super(http, errorHandlerService);
    }

    getVideoConfig() {
      return this.get(`${this.env.publicApiSocioUrl}v1/socio/video-sections`);
    }
}
